import { FC, PropsWithChildren } from 'react';

interface ITableRowActionsProps extends PropsWithChildren {
  classname?: string;
  style?: any;
}

/**
 * @param classname: string
 * @param style: style object
 * @description a modal for Deleting demand.
 */

const TableRowActions: FC<ITableRowActionsProps> = (props) => {
  const { classname, children, style } = props;
  return (
    <div className={classname} style={style}>
      {children}
    </div>
  );
};

export { TableRowActions };
